// extracted by mini-css-extract-plugin
module.exports = {"pageWrap":"style-module--pageWrap--1PGzz","headWrap":"style-module--head-wrap--25KOk","content":"style-module--content--1Q1BR"};